export default "__VITE_ASSET__ea1s3nuB__"